import React, { useState, useEffect } from 'react';
import { UserList } from './userManagement/UserList';
import { SearchUser } from './userManagement/SearchUser';
import AdminFilterSelection from './AdminFilterSelection';
import AdminAccountFilterSelection from './AdminAccountFilterSelection';
import SystemAlerts from 'src/component/SystemAlerts';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import useReduxState from 'src/hooks/useReduxState';
import AlertContentWithFlag from '../Checkout/AlertContentWithFlag';
import AccountList from './Accounts/AccountList';
import { SearchAcct } from './Accounts/SearchAcct';
import { SearchReport } from './Reports/SearchReport';
import ReportList from './Reports/ReportList';

import AdminConsoleHeader from './AdminConsoleHeader';
import AdminConfig from "@system/config/admin";
import System from 'src/helper/system';
import Constants from 'src/support/Constants';
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import { useAccountStore } from 'src/hooks/admin/account';

const UserManagementTab = (props) => {
    let c = System.getParams().tab;
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [{ }, { }, { set_account_list }] = useAccountStore();
    const [userListErrAlert, setUserListErrAlert] = useReduxState("", 'setUserListErrAlert');
    const [errAlertType] = useReduxState("", 'setErrAlertType');
    const [activeTab, setActiveTab] = useState(c ? c : Constants.adminConsoleTab.User)
    const [{ }, { }, { clear_all_filter }] = useAdminAccountFilterStore();

    const onChangeTab = (tab) => {
        setUserListErrAlert('');
        set_account_list()
        clear_all_filter()
        setActiveTab(tab)
        var newUrl = AdminConfig.getAdminUserManagementURL() + '?tab=' + tab;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }

    return (
        <>
            <div className='adminconsole-container'>
                <AdminConsoleHeader title={activeTab == Constants.adminConsoleTab.User ? 'USER MANAGEMENT' : activeTab == Constants.adminConsoleTab.Account ? 'ACCOUNT MANAGEMENT' : 'REPORT MANAGEMENT'} tab={activeTab} />

                <div className="bs5 row mt-2">
                    <div className='col-12'>
                        {(latest_system_notification_data?.errorModule !== undefined && latest_system_notification_data?.errorModule === 'addUser') &&
                            <SystemAlerts />
                        }
                        {(latest_system_notification_data?.errorModule !== undefined && latest_system_notification_data?.errorModule === 'searchUser') &&
                            <SystemAlerts />
                        }
                        {userListErrAlert &&
                            <AlertContentWithFlag message={userListErrAlert} type={errAlertType ? errAlertType : "danger"} isDisplay={errAlertType == 'success' ? true : false} isDisplayIcon={errAlertType == 'danger' ? true : false} callBackFunc={() => {
                                setUserListErrAlert('');
                            }} />
                        }
                    </div>
                </div>

                <div className='adminuser-tabs'>
                    <div className='container'>
                        <ul className="bs5 nav nav-tabs">
                            <li>
                                <a className={"text-uppercase font-bold " + (activeTab === Constants.adminConsoleTab.User ? 'active' : '')} onClick={() => onChangeTab(Constants.adminConsoleTab.User)}><span>USERS</span></a>
                            </li>
                            <li>
                                <a className={"text-uppercase font-bold " + (activeTab === Constants.adminConsoleTab.Account ? 'active' : '')} onClick={() => onChangeTab(Constants.adminConsoleTab.Account)}><span>ACCOUNTS</span></a>
                            </li>
                            <li>
                                <a className={"text-uppercase font-bold " + (activeTab === Constants.adminConsoleTab.Report ? 'active' : '')} onClick={() => onChangeTab(Constants.adminConsoleTab.Report)}><span>REPORTS</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
                {activeTab === Constants.adminConsoleTab.User ?
                    <div>
                        <div className='acsearchuser'>
                            <SearchUser />
                        </div>
                        <AdminFilterSelection />
                        <div>
                            <UserList />
                        </div>
                    </div> :
                    activeTab === Constants.adminConsoleTab.Account ?
                        <div>
                            <div className='acsearchuser'>
                                <SearchAcct />
                            </div>
                            <AdminAccountFilterSelection />
                            <div>
                                <AccountList />
                            </div>
                        </div> :
                        <div>

                            <div className='acsearchuser'>
                                <SearchReport />
                            </div>
                            <AdminAccountFilterSelection />
                            <div>
                                <ReportList />
                            </div>
                        </div>

                }

            </div>

        </>
    );
}

export default UserManagementTab;